import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { UsersValidation } from "acquaint-api/validation/UsersValidation";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { DxToolbarItem } from "devextreme-vue/popup";
import { ValidatedEvent } from "devextreme/ui/validator";
import { computed, inject, ref, watch } from "vue";
import { ChangePassword } from "../../types/user/ChangePassword";
import AcquaintTextbox from "../ui/inputs/acquaint-textbox.vue";
import ModalBase from "../ui/modals/modal-base.vue";

const confirmNewPasswordValidationError =
  "Password does not match the New Password";

export default /*#__PURE__*/_defineComponent({
  __name: 'change-password',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes.
   * This is used to update the v-model variable in the parent component and control the visibility of the modal.
   * @property {boolean} value - The updated state to reflect whether the modal should be shown or hidden.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;

const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;





const showPopup = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

// Reset filled in data when modal is closed
watch(
  () => showPopup.value,
  (value) => {
    if (!value) {
      passwordData.value.currentPassword = "";
      passwordData.value.newPassword = "";
      passwordData.value.confirmNewPassword = "";
    }
  },
);

const updatePassword = async (e: any) => {
  const validation: ValidatedEvent = e.validationGroup.validate();

  // Don't continue if user has entered invalid data
  if (!validation.isValid) {
    return;
  }

  try {
    await acquaintApiClient.httpPostVoid(`/app/user/changepassword`, {
      currentPassword: passwordData.value.currentPassword,
      newPassword: passwordData.value.newPassword,
    });

    /* Changing password will invalidate current database connector token so it needs to refreshed
     * This avoids 401 unauthorized errors occuring */
    await acquaintApiClient.RefreshDatabaseConnectionToken(
      passwordData.value.newPassword,
    );

    // Hide the form as the user has successfully updated their password
    closeForm();
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

const passwordData = ref<ChangePassword>({
  currentPassword: "",
  newPassword: "",
  confirmNewPassword: "",
});

const closeForm = () => {
  showPopup.value = false;
  passwordData.value.currentPassword = "";
  passwordData.value.newPassword = "";
  passwordData.value.confirmNewPassword = "";
};

// Custom error handling for new password fields
const newPasswordValidation = () => {
  if (passwordData.value.newPassword === passwordData.value.currentPassword) {
    newPasswordValidationError.value =
      "New Password cannot be the same as Current Password";
    return false;
  }

  if (passwordData.value.newPassword.length < 4) {
    newPasswordValidationError.value =
      "New Password must be a minimum of 4 characters";
    return false;
  }

  return true;
};

const newPasswordValidationError = ref("");

const confirmNewPasswordValidation = () =>
  passwordData.value.confirmNewPassword === passwordData.value.newPassword;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showPopup.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showPopup).value = $event)),
    title: "Change Password"
  }, {
    content: _withCtx(() => [
      _createVNode(AcquaintTextbox, {
        modelValue: passwordData.value.currentPassword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((passwordData.value.currentPassword) = $event)),
        "field-validation": _unref(UsersValidation).Password,
        label: "Current Password",
        "validation-group": "change-password"
      }, null, 8, ["modelValue", "field-validation"]),
      _createVNode(AcquaintTextbox, {
        modelValue: passwordData.value.newPassword,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordData.value.newPassword) = $event)),
        "field-validation": _unref(UsersValidation).Password,
        label: "New Password",
        "custom-validation": newPasswordValidation,
        "invalid-message": newPasswordValidationError.value,
        "validation-group": "change-password"
      }, null, 8, ["modelValue", "field-validation", "invalid-message"]),
      _createVNode(AcquaintTextbox, {
        modelValue: passwordData.value.confirmNewPassword,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordData.value.confirmNewPassword) = $event)),
        "field-validation": _unref(UsersValidation).Password,
        label: "Confirm New Password",
        "custom-validation": confirmNewPasswordValidation,
        "invalid-message": confirmNewPasswordValidationError,
        "validation-group": "change-password"
      }, null, 8, ["modelValue", "field-validation"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Save',
          onClick: (e) => {
            updatePassword(e);
          },
          validationGroup: 'change-password',
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            closeForm();
          },
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})